import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.partial_delivery_reasons`. */
export const editPartialDeliveryReasons = async (reasons: string[]): Promise<any> =>
  writeSettingsFields({ partial_delivery_reasons: reasons });
